import PropTypes from 'prop-types';
import React from 'react';
import ShoppingSearch from '../search';
import ShoppingBreadcrumbsBar from '../breadcrumbs_bar';

export default function ProductDetailsNavigation({ shoppingNavigation }) {
  const { breadcrumbs } = shoppingNavigation;

  return (
    <div className="product-details-shopping-nav">
      <div className="nav-wrapper">
        <ShoppingSearch />
        <ShoppingBreadcrumbsBar breadcrumbs={breadcrumbs} />
      </div>
    </div>
  );
}

ProductDetailsNavigation.propTypes = {
  shoppingNavigation: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        path: PropTypes.string
      })
    )
  })
};
